<template>
<vx-card>
  <vs-popup :active.sync="showMissionsPopup" :title="'Prestations du contrat N°' + selectedContract">
    <!-- MISSIONS -->
    <div style="width: 1000px;">
      <MissionPopupTable :missions="missionsOfSociety"/>
    </div>
    <!-- /MISSIONS -->
  </vs-popup>
  <div class="vx-col">
    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <h3>Dupliquer un achat</h3>
      </div>
      <!-- BOUTON DE RETOUR -->
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <vs-button
          v-if="!showNetlinkPopup"
          class="float-right"
          radius
          color="primary"
          type="filled"
          icon-pack="feather"
          icon="icon-x"
          @click="returnPrevRoute"
        ></vs-button>
      </div>
      <!-- /BOUTON DE RETOUR -->
    </div>

    <div class="vx-row">
      <!-- CLIENT -->
      <div class="vx-col sm:w-1/4 w-full mb-2">
	  	<label for="" class="vs-select--label">Client</label>
		  <div class="flex">
			<vs-select
				v-model="selectedSociety"
				class="w-full select-medium mr-2"
				:disabled="purchaseDefinitiveLock"
				autocomplete
				:style="styleValidator('selectedSociety')"
				@change="validateOne(selectedSociety, 'selectedSociety')"
			>
			<vs-select-item
				:key="index"
				:value="item.id"
				:text="item.name"
				v-for="(item, index) in societies"
				class="w-full"
			/>
			</vs-select>
			<vx-tooltip v-if="validators['selectedSociety'] && validators['selectedSociety'].errText !== ''" :text="errText('selectedSociety')" class="ml-3">
				<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
			</vx-tooltip>
		  </div>
      </div>
      <!-- /CLIENT -->
      <!-- CONTRAT -->
      <div class="vx-col sm:w-1/4 w-full mb-2" v-if="!is_dns">
	  	<label for="" class="vs-select--label">Contrat</label>
		  <div class="flex">
			<vs-select
				autocomplete
				v-model="selectedContract"
				class="w-full select-medium mr-2"
				:disabled="purchaseLocked"
				:style="styleValidator('selectedContract')"
				@change="validateOne(selectedContract, 'selectedContract')"
			>
			<vs-select-item
				:key="index"
				:value="item.id"
				:text="item.id + ' - ' + products_categories[item.delivery - 1]"
				v-for="(item, index) in contractOptions"
				class="w-full"
			/>
			</vs-select>
			<vx-tooltip v-if="validators['selectedContract'] && validators['selectedContract'].errText !== ''" :text="errText('selectedContract')" class="ml-3">
				<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
			</vx-tooltip>
		  </div>
      </div>
      <!-- /CONTRAT -->

	  
	  <!-- PRESTATION -->
      <div class="vx-col sm:w-1/8 mb-2" v-if="!is_dns">
	  	<label for="" class="vs-select--label">Prestation</label>
		  <div class="flex">
			<vs-select
				autocomplete
				v-model="selectedProduct"
				class="w-full select-medium mr-2"
				:disabled="purchaseLocked"
				no-data="Aucune prestation"
				:style="styleValidator('selectedProduct')"
				@change="validateOne(selectedProduct, 'selectedProduct')"
				id="product_options"
			>
			<vs-select-item
				:key="index"
				:value="item[0]"
				:text="item[1]"
				v-for="(item, index) in productOptions"
				class="w-full"
			/>
			</vs-select>
			<vx-tooltip v-if="validators['selectedProduct'] && validators['selectedProduct'].errText !== ''" :text="errText('selectedProduct')" class="ml-3">
				<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
			</vx-tooltip>
		  </div>
      </div>
      <!-- /PRESTATION -->


      <!-- SERVICE -->
      <div class="vx-col sm:w-1/4 w-full mb-2">
	  	<label for="" class="vs-select--label">Service</label>
		  <div class="flex">
			<vs-select
				v-model="selectedService"
				class="w-full select-medium mr-2"
				:disabled="purchaseDefinitiveLock"
				autocomplete
				:style="styleValidator('selectedService')"
				@change="validateOne(selectedService, 'selectedService')"
			>
			<vs-select-item
				:key="index"
				:value="item"
				:text="getServiceName(item)"
				v-for="(item, index) in serviceOptions"
				class="w-full"
			/>
			</vs-select>
			<vx-tooltip v-if="validators['selectedService'] && validators['selectedService'].errText !== ''" :text="errText('selectedService')" class="ml-3">
				<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
			</vx-tooltip>
		  </div>
      </div>
      <!-- /SERVICE -->
      <!-- PRESTATAIRE -->
      <div class="vx-col sm:w-1/4 w-full mb-2">
	  	<label for="" class="vs-select--label">Prestataire</label>
		  <div class="flex">
			<vs-select
				v-model="selectedProvider"
				class="w-full select-medium mr-2"
				:disabled="purchaseDefinitiveLock"
				autocomplete
				:style="styleValidator('selectedProvider')"
				@change="validateOne(selectedProvider, 'selectedProvider')"
			>
			<vs-select-item
				:key="index"
				:value="item.id"
				:text="item.society"
				v-for="(item, index) in providers"
				class="w-full"
			/>
			</vs-select>
			<vx-tooltip v-if="validators['selectedProvider'] && validators['selectedProvider'].errText !== ''" :text="errText('selectedProvider')" class="ml-3">
				<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
			</vx-tooltip>
		  </div>
      </div>
      <!-- /PRESTATAIRE -->

    </div>

    <div class="vx-row">
      <!-- PRIX D'ACHAT -->
      <div v-if="![netlinkServiceId, netlinkClientServiceId, dnsServiceId, dnsClientServiceId].includes(selectedService)" class="vx-col sm:w-1/4 w-full mb-2 mt-2 nowrap">
        <vs-input
          class="w-full"
          :disabled="purchaseLocked"
          label-placeholder="Prix d'achat"
          v-model="selectedPrice"
          :style="styleValidator('selectedPrice')"
          @change="validateOne(selectedPrice, 'selectedPrice')"
        />
        €
        <vx-tooltip v-if="validators['selectedPrice'] && validators['selectedPrice'].errText !== ''" :text="errText('selectedPrice')" class="ml-3">
          <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
        </vx-tooltip>
      </div>
      <!-- /PRIX D'ACHAT -->
      <!-- REFACTURABLE -->
      <div v-if="type != 'DNS' && is_dns == false  && ![netlinkServiceId, dnsServiceId].includes(selectedService)" class="vx-col sm:w-1/4 w-full mb-2">
        <vs-checkbox :disabled="purchaseLocked || lockBillable" v-model="purchase.isBillable">Facturable</vs-checkbox>
      </div>
      <!-- /REFACTURABLE -->

      <div v-if="purchase.isBillable" class="vx-col sm:w-1/4 w-full mb-2 nowrap">
        <vs-input
          class="w-full"
          :disabled="purchaseLocked"
          label-placeholder="Prix de vente"
          v-model="selectedSellPrice"
          :style="styleValidator('selectedSellPrice')"
          @change="validateOne(selectedSellPrice, 'selectedSellPrice')"
        />
        €
        <vx-tooltip v-if="validators['selectedSellPrice'] && validators['selectedSellPrice'].errText !== ''" :text="errText('selectedSellPrice')" class="ml-3">
          <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
        </vx-tooltip>
      </div>

      <!-- MARGE PRIX
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          v-show="purchase.isBillable"
          class="w-full"
          :disabled="purchaseLocked"
          label-placeholder="Marge Prix"
          v-model="selectedMarginPrice"
        />      </div>
       MARGE /PRIX -->
      <!-- MARGE TAUX
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          v-show="purchase.isBillable"
          class="w-full"
          :disabled="purchaseLocked"
          label-placeholder="Marge Taux"
          v-model="purchase.marginRate"
        />      </div>
       MARGE /TAUX -->
      <!-- FREQUENCY -->
      <!-- <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-select
          autocomplete
          v-model="purchase.recurrence"
          class="w-full select-medium mr-2"
          :disabled="purchaseLocked"
          label="Fréquence de la récurrence"
          placeholder=""
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in frequencyOptions"
            class="w-full"
          />
        </vs-select>
      </div> -->
      <!-- /FREQUENCY -->
      <!-- DATE -->
      <!-- <div class="vx-col sm:w-1/4 w-full mb-2">
      <vx-input-group class="w-full bottom">
          <template slot="prepend">
            <div class="prepend-text bg-primary">
              <span class="flex"
                ><vs-icon icon="calendar_today" size="small"></vs-icon
              ></span>
            </div>
          </template>
          <flat-pickr
            class="w-full"
            v-model="purchase.boughtAt"
            placeholder="Date d'achat"
            :disabled="purchaseLocked"
            :config="configDatePicker"
            :style="styleValidator('boughtAt')"
            @input="validateOne(purchase.boughtAt, 'boughtAt')"
          />
        </vx-input-group>
        <vx-tooltip v-if="validators['boughtAt'] && validators['boughtAt'].errText !== ''" :text="errText('boughtAt')" class="ml-3">
          <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
        </vx-tooltip>
      </div> -->
      <!-- /DATE -->
    </div>

	<div class="vx-row w-full mb-2" style="margin-left: 0px; margin-top: 5px;">
		<vx-input-group
			class="bottom"
		>
			<label for="flatpickr" style="font-size: 9px; margin-left: 3px;">Période</label>
			<br />
			<flat-pickr
				id="flatpickr"
				v-model="period"
				:config="configDatePickerMonth"
				style="width: 100px; text-align: center;"
				@keydown.native.delete.capture.stop.prevent
				:disabled="purchaseLocked"
			/>
		</vx-input-group>
	</div>

    <div class="vx-row">
      <!-- COMMENTAIRE -->
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <vs-input
          v-model="purchase.commentary"
          label="Commentaire"
          class="mb-0 md:mt-10 mt-6"
          :disabled="purchaseLocked"
        />
      </div>
      <!-- /COMMENTAIRE -->
    </div>
    <div class="vx-row">
      <div class="vx-col sm:3/4"></div>
      <div class="vx-col sm:1/4">
        <vs-button
          v-if="purchaseLocked"
          class="float-right"
          color="primary"
          type="filled"
          @click="enterEditMode"
        >Modifier Achat
      </vs-button></div>
      <div class="vx-col align-center">
        <vs-button
          v-if="selectedContract"
          color="primary"
          type="filled"
          @click="displayMissionsPopup"
        >Voir les prestations du contrat
        </vs-button>
      </div>
    </div>
    <div class="vx-row">
      <!-- NETLINK POPUP -->
      <div class="vx-col  w-full mb-2">
        <span v-show="showNetlinkPopup || (atLeastOneNetlink && editPurchaseMode)"><NetlinkPopupTable ref="netlinkPopup"  :purchaseId="purchaseId" :societyId="selectedSociety" @netlink-update="checkNetlinkNumber($event)"/></span>
        <span v-show="showDnsPopup && selectedService == dnsServiceId"><DnsPopupTable ref="dnsPurchasePopup" :purchaseId="purchaseId" :providerId="selectedProvider" :price="purchase.price"/></span>
      </div>
      <!-- /NETLINK POPUP -->
    </div>
    <div class="vx-row float-right mt-3">
      <div class="vx-col w-full">
        <!-- REINITIALISER -->
        <!-- <vs-button
          color="warning"
          type="border"
          class="mb-2 mr-3"
          @click="
            purchase.firstname = purchase.lastname = purchase.email = purchase.phone = purchase.image_url = purchase.commentary = purchase.role =
              ''
          "
          >Réinitialiser</vs-button
        > -->
        <!-- /REINITIALISER -->
        <!-- SUBMIT -->
        <vs-button v-if="is_netlink && !showNetlinkPopup && !editPurchaseMode" class="mb-2" @click="formSubmittedAndShowNetlink">Enregistrer et Ajouter Netlink</vs-button>
        <vs-button v-else-if="is_dns && !showNetlinkPopup && !showDnsPopup && !editPurchaseMode" class="mb-2" @click="formSubmittedAndShowDns">Enregistrer et Ajouter NDD</vs-button>

        <!-- <vs-button v-if="is_netlink && !showNetlinkPopup && editPurchaseMode" class="mb-2" @click="editFormSubmittedAndShowNetlink">Enregistrer et Ajouter Netlink</vs-button> -->
        <!-- <vs-button v-if="!is_netlink && !showNetlinkPopup && !editPurchaseMode" class="mb-2" @click="submitForm">Enregistrer Achat</vs-button> -->
        <!-- <vs-button v-if="!is_netlink && !showNetlinkPopup && editPurchaseMode" class="mb-2" @click="editFormSubmitted">Enregistrer Achat</vs-button> -->
        <!-- <vs-button v-if="showNetlinkPopup && atLeastOneNetlink" class="mb-2" @click="netlinkSubmitted">Enregistrer</vs-button> -->
        <vs-button v-else class="mb-2" @click="submitForm">Enregistrer</vs-button>

        <!-- /SUBMIT -->
      </div>
    </div>
  </div>
  </vx-card>
</template>

<script>
import VueCookies from "vue-cookies";
import MissionPopupTable from "@/components/tables/MissionPopupTable";
import NetlinkPopupTable from "@/components/tables/NetlinkPopupTable";
import DnsPopupTable from "@/components/tables/DnsPopupTable";
import Purchase from "@/entities/Purchase";
import Contract from "@/entities/Contract";
import Provider from "@/entities/Provider";
import Validator from "@/entities/Validator";
import Mission from "@/entities/Mission";
import store from "@/store/store";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";

export default {
	name: "RenewPurchaseForm",
	mixins: [dbFieldConvertor],
	props: {
		chartParams: Object,
		isPercent: Boolean
	},
	components: {
		flatPickr,
		MissionPopupTable,
		NetlinkPopupTable,
		DnsPopupTable,
		VxTooltip
	},
	data() {
		return {
			// USER OBJECT
			purchase: Purchase.getFormFields(),
			apiUrl: this.$store.state.backendApiUrl,
			// FORM SELECT OPTIONS
			statusOptions: [
				{text: "Actif", value: 1},
				{text: "Inactif", value: 0}
			],
			frequencyOptions: [
				{text: "One shot", value: 0},
				{text: "Mensuel", value: 1},
				{text: "Bimestriel", value: 2},
				{text: "Trimestriel", value: 3},
				{text: "Quadrimestriel", value: 4},
				{text: "Semestriel", value: 5},
				{text: "Annuel", value: 6}
			],
			/**
			 * Refer to backend server to understand more about type and its possible value
			 */
			typeOptions: [
				{text: "Commercial", value: 2},
				{text: "Consultant", value: 3}
			],
			contractOptions: [],
			productOptions: [],
			providerOptions: [],
			serviceOptions: [],
			missionsOfSociety: [],
			selectedSociety: null,
			selectedContract: null,
			selectedProduct: null,
			selectedProvider: null,
			selectedService: null,
			selectedPrice: null,
			selectedMarginPrice: null,
			purchaseLocked: false,
			purchaseDefinitiveLock: false,
			lockBillable: false,
			editPurchaseMode: false,
			is_netlink: false,
			is_netlinkclient: false,
			netlinkServiceName: "Netlinking",
			netlinkClientServiceName: "Netlinking Client",
			dnsClientServiceName: "Domaine Client",
			netlinkServiceId: null,
			netlinkClientServiceId: null,
			dnsClientServiceId: null,
			is_dns: false,
			is_dnsclient: false,
			dnsServiceName: "Domaine",
			dnsServiceId: null,
			showMissionsPopup: false,
			showNetlinkPopup: false,
			showDnsPopup: false,
			atLeastOneNetlink: false,
			purchaseId: null,
			validators: {},
			check: true,
			period: null,
			configDatePickerMonth: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light"
					})
				],
			},
			initial: 0
		};
	},
	created() {
		// this.configEndDatePicker.minDate = new Date(this.configEndDatePicker.minDate.getFullYear(), this.configEndDatePicker.minDate.getMonth(), 1)
		this.getAllSocieties();
		this.$store.dispatch("getAllProducts");
		this.getAllProviders();
		this.getAllServices();
		this.getAllProductsCategories();
	},
	mounted() {
		this.$http.get(this.apiUrl + "purchase/get/" + this.$route.params.purchaseId)
			.then(purchase => {
				this.purchase = new Purchase(purchase.data[0]);
				let today = new Date(Date.now());
				this.period = `${today.getMonth() + 1}/${today.getFullYear()}`;
				this.purchase.boughtAt = today.toISOString();
				this.selectedSociety = this.purchase.contract_society_id;
				this.selectedContract = this.purchase.contract_id;
				this.selectedProduct = this.purchase.mission_id;
				this.selectedProvider = this.purchase.users_id;
				this.serviceOptions = this.setServiceOptionsAndSetService(this.selectedProvider, this.purchase.service_id);
				this.selectedPrice = this.convertInternationalNumberToFrench(this.purchase.price);
				this.selectedMarginPrice = this.convertInternationalNumberToFrench(this.purchase.marginPrice);
				// this.setProviderOptions(this.selectedService)
				this.is_netlink = this.checkServiceIsNetlink(this.selectedService);
				this.is_dns = this.checkServiceIsDns(this.selectedService);
			});
	},
	computed: {
		societies: () => {
			return store.state.societies;
		},
		products: () => {
			return store.state.products;
		},
		providers: () => {
			return store.state.providers;
		},
		services: () => {
			return store.state.services;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		products_categories: () => {
			return store.state.products_categories.map(row => row.name);
		}
	},
	watch: {
		selectedSociety: function(data){
			//console.log("selectedSociety watch");
			this.purchase.contract_society_id = data;
			this.getAllContractsForSociety(data);
			if(this.is_dns) this.getAllMissionsForContract(1);
		},
		selectedContract: function(data){
			//console.log("selectedContract watch");
			this.purchase.contract_id = data;
			if(this.is_dns) this.getAllMissionsForContract(1);
			else this.getAllMissionsForContract(data);
			this.initial++
		},
		selectedProvider: function(){
			//console.log("selectedProvider watch");
			this.purchase.users_id = this.selectedProvider;
			/*
			 * this.serviceOptions = this.setServiceOptions(this.selectedProvider)
			 * this.selectedService = this.serviceOptions[0]
			 */
		},
		selectedService: function(data){
			//console.log("selectedService watch");
			this.purchase.service_id = data;
			this.setProviderOptions(data);
			this.is_netlink = this.checkServiceIsNetlink(data);
			this.is_dns = this.checkServiceIsDns(data);

			if(this.is_dns) this.getAllMissionsForContract(1);
			else this.getAllMissionsForContract(this.selectedContract);

			this.is_dnsclient = data == this.dnsClientServiceId ? true : false;
			this.is_netlinkclient = data == this.netlinkClientServiceId ? true : false;
			if(this.is_dnsclient || this.is_netlinkclient){
				this.purchase.isBillable = true;
				this.lockBillable = true;
			}
			else{
				this.lockBillable = false;
			}
		},
		is_netlink: function(){
			if(this.is_netlink){
				//console.log("is_netlink", this.is_netlink);
			}
		},
		services: function(){
			this.setNetlinkAndDnsId();
		}
	},
	methods: {
		validateOne(val, name){
			//console.log(name, val);
			let value = val;
			value === 0 ? value = "0" : "";
			let constname = "";
			if(name == "boughtAt"){
				constname = "dateConstraint";
				this.validators[name] = new Validator({constraintName: constname});
				if(this.purchase.boughtAt == 0 || this.purchase.boughtAt == null){
					this.validators[name].valid = false;
					this.validators[name].errText = "Ce champ ne peut être vide.";
					this.check = false;
				}
				else{
					this.validators["boughtAt"].errText = "";
					this.validators[name].valid = true;
				}
			}
			else{
				switch(name){
				case"selectedPrice":
					/*
					 * case "selectedMarginPrice":
					 * case "marginRate":
					 */
				case"selectedSellPrice":
					value ? value = String(val) : "";
					constname = "priceConstraint";
					break;
				default:
					value ? value = String(val) : "";
					value == null ? value = "" : "";
					constname = "isNumberConstraint";
					break;
				}
				this.validators[name] = new Validator({constraintName: constname});
				this.validators[name].check(value);
				val == null ? this.validators[name].valid = false : "";
				this.validators[name].valid == false && this.validators[name].errText == "" ? this.validators[name].errText = "Ce champ ne peut être vide." : "";
				this.validators[name].valid == false && this.validators[name].errText !== "" ? this.check = false : "";
			}
			this.$forceUpdate();
		},
		errText(name){
			if(this.validators[name] && this.validators[name].errText !== ""){
				return this.validators[name].errText;
			}
		},
		styleValidator(name){
			if(this.validators && this.validators[name] && this.validators[name].valid == false && this.validators[name].errText !== ""){
				switch(name){
				case"boughtAt":
					return "border: 1px solid red !important; border-radius: 0 5px 5px 0;";
				default:
					return "border: 1px solid red !important; border-radius: 5px;";
				}
			}
			else if(this.validators && this.validators[name] && this.validators[name].errText == ""){
				switch(name){
				case"boughtAt":
					return "border: 1px solid green !important; border-radius: 0 5px 5px 0;";
				default:
					return "border: 1px solid green !important; border-radius: 5px;";
				}
			}
			else{
				return "border: none !important; border-radius: none;";
			}
		},
		setProviderOptions(service_id){
			let providerOptions = [];
			for(let i = 0; i < this.providers.length; i++){
				let providerServices = this.providers[i].service_id_list.split(",");
				// //console.log("providerServices", providerServices, service_id)
				if(providerServices.includes(service_id.toString())){
					// //console.log("INCLUDES")
					providerOptions.push(this.providers[i]);
				}
			}

			// this.providers.filter(provider => provider.service_id_list.split(',').includes(service_id))
			this.providerOptions = providerOptions;
			/*
			 * if(providerOptions.length > 0){
			 *   this.selectedProvider = this.providerOptions[0].id
			 * }
			 */
		},
		getFormatedDate(date){
			let today = new Date(Date.now());
			return date ? date.substring(0, 10) : today.toISOString().substring(0, 10);
		},
		getServiceId(service_name){
			let service = this.services.find(service_element => service_element.name == service_name);
			return service.id;
		},

		setNetlinkAndDnsId(){
			this.netlinkServiceId = this.getServiceId(this.netlinkServiceName);
			this.dnsServiceId = this.getServiceId(this.dnsServiceName);
			this.dnsClientServiceId = this.getServiceId(this.dnsClientServiceName);
			this.netlinkClientServiceId = this.getServiceId(this.netlinkClientServiceName);
		},

		addPurchase(isDNS=false){
			return new Promise((resolve, reject) => {
				let today = new Date(Date.now());
				let formatedDate = this.purchase.boughtAt ? this.purchase.boughtAt.substring(0, 10) : today.toISOString().substring(0, 10);
				formatedDate = formatedDate.split("/").reverse().join("-");
				formatedDate = formatedDate + " 02:00:00";

				let period = `${this.period.split("/").reverse().join("-")}-01 02:00:00`;

				if(isDNS == true){
					// this.purchase = this.$refs.dnsPurchasePopup.getPurchaseData()
					this.$refs.dnsPurchasePopup.getPurchasePrice()
						.then(result => {
							this.purchase.price = result;
							this.$http.post(this.apiUrl + "purchase/add", {
								price: this.convertFrenchNumberToInternational(this.purchase.price),
								sell_price: this.convertFrenchNumberToInternational(this.selectedSellPrice),
								recurrence: this.purchase.recurrence,
								margin_price: this.convertFrenchNumberToInternational(this.selectedMarginPrice),
								margin_rate: this.purchase.marginRate,
								is_billable: this.purchase.isBillable,
								commentary: this.purchase.commentary,
								bought_at: formatedDate,
								contract_id: 1,
								contract_society_id: this.selectedSociety,
								users_id: this.selectedProvider,
								service_id: this.selectedService,
								is_delivered: 0,
								recurrence_active: this.purchase.recurrence,
								user_id: this.activeUser.id,
								period_date: period,
								mission_id: this.missionsOfSociety.filter(mission => mission.contract_id == 1 && mission.products_id == 105)[0].id
							}).then(res => {
								// //console.log(res)
								this.purchaseId = res.data.insertId;
								/*
								 * //console.log(this.purchaseId)
								 * this.showNetlinkPopup = true
								 */
								this.$store.dispatch("getAllPurchasesWithRecurring");
								// Send a success notification to the user
								this.$vs.notify({title: "Succès", text: "Achat ajouté avec succès."});
								resolve(res.data.insertId);
							}).catch(err => {
								//console.log(err);
								this.$vs.notify({title: "Echec", text: "L'achat n'a pas été ajouté."});
								reject(null);
							});
						});
				}
				else{
					this.$http.post(this.apiUrl + "purchase/add", {
						price: this.selectedService == this.netlinkServiceId ? this.$refs.netlinkPopup.getPurchasePrice() : this.convertFrenchNumberToInternational(this.selectedPrice),
						sell_price: this.convertFrenchNumberToInternational(this.selectedSellPrice),
						recurrence: this.purchase.recurrence,
						margin_price: this.convertFrenchNumberToInternational(this.selectedMarginPrice),
						margin_rate: this.purchase.marginRate,
						is_billable: this.purchase.isBillable,
						commentary: this.purchase.commentary,
						bought_at: formatedDate,
						contract_id: this.selectedContract,
						contract_society_id: this.selectedSociety,
						users_id: this.selectedProvider,
						service_id: this.selectedService,
						is_delivered: 0,
						recurrence_active: this.purchase.recurrence,
						user_id: this.activeUser.id,
						period_date: period,
						mission_id: this.selectedProduct
					}).then(res => {
						// //console.log(res)
						this.purchaseId = res.data.insertId;
						/*
						 * //console.log(this.purchaseId)
						 * this.showNetlinkPopup = true
						 */
						this.$store.dispatch("getAllPurchasesWithRecurring");
						// Send a success notification to the user
						this.$vs.notify({title: "Succès", text: "Achat ajouté avec succès."});
						resolve(res.data.insertId);
					}).catch(err => {
						//console.log(err);
						this.$vs.notify({title: "Echec", text: "L'achat n'a pas été ajouté."});
						reject(null);
					});
				}
				/*
				 * else{
				 *   purchasePrice
				 *   this.purchase = this.$refs.netlinkPurchasePopup.getPurchaseData()
				 * }
				 */

			});
		},

		addDNS(){ // CREATE DNS OBJECT
			return new Promise((resolve, reject) => {
				this.oneDns = this.$refs.dnsPurchasePopup.getDnsData();
				//console.log("this.purchaseId", this.purchaseId);
				if(this.purchaseId){
					//console.log(this.purchaseId);
					this.oneDns.purchase_id = this.purchaseId;
				}
				if(this.providerId){
					//console.log(this.providerId);
					this.oneDns.provider_id = this.providerId;
				}
				let today = new Date(Date.now());
				let formatedDate = this.purchase.boughtAt ? this.purchase.boughtAt.substring(0, 10) : today.toISOString().substring(0, 10);

				formatedDate = formatedDate.split("/").reverse().join("-");
				formatedDate = formatedDate + " 02:00:00";

				this.$refs.dnsPurchasePopup.submitAllDns(this.purchaseId, formatedDate, this.providerId)
					.then(result => {
						resolve(result);
					})
					.catch(err => {
						reject(err);
					});
				/*
				 * this.oneDns.purchase_date = formatedDate
				 * this.oneDns.renew_date = formatedDate
				 * let newDns = new Dns(this.oneDns)
				 * //console.log(newDns)
				 * newDns.create((err, res) => {
				 *   if(err){
				 *     //console.log(err)
				 *     reject(err)
				 *   }
				 *   if(res) {
				 *     //console.log(res)
				 *     this.$store.dispatch("getAllDns");
				 *     resolve(res.data.insertId)
				 *   }
				 * })
				 */
			});
		},

		createNetlink(isDNS, netlink){
			return new Promise((resolve, reject) => {
				/*
				 * this.netlink =
				 * this.netlink.landingPage = this.netlink.landingPage;
				 * this.netlink.urlBought = this.netlink.urlBought;
				 */

				/*
				 * if(isDNS){
				 *   netlink.dns_id = this.selectedDns
				 * }
				 */

				if(this.purchaseId){
					//console.log(this.purchaseId);
					netlink.purchase_id = this.purchaseId;
				}
				//console.log("this.society_id", this.society_id);
				if(this.society_id){
					//console.log(this.society_id);
					netlink.society_id = this.society_id;
				}

				//console.log("this.selectedContract", this.selectedContract);
				if(this.selectedContract){
					//console.log(this.selectedContract);
					netlink.contract_id = this.selectedContract;
				}

				/*
				 * let newNetlink = new Netlink(netlink)
				 * //console.log(newNetlink)
				 */
				netlink.create((err, res) => {
					if(err) //console.log(err);
					if(res) {
						//console.log(res.data.insertId);
						this.$store.dispatch("getAllNetlink");
						netlink.id = res.data.insertId;
						// this.netlink_list.push(newNetlink)
						resolve(res.data.insertId);
					}
				});
			});
		},

		addNetlink(isDNS=false){ // IMPLEMENT DNS LINKING
			return new Promise((resolve, reject) => {
				this.netlink_list = this.$refs.netlinkPopup.getNetlinkListData();
				let requests = [];
				for(let netlink of this.netlink_list){
					requests.push(this.createNetlink(isDNS, netlink));
				}
				Promise.all(requests)
					.then(responses => {
						resolve(responses);
					});
			});
		},

		submitForm(){
			this.check = true;
			let fields = ["selectedSociety", "selectedContract", "selectedProduct", "selectedService", "selectedProvider", "selectedPrice"];
			let fieldsVal = [this.selectedSociety, this.selectedContract, this.selectedProduct, this.selectedService, this.selectedProvider, this.selectedPrice];

			if(this.is_dns){
				fields = ["selectedSociety", "selectedService", "selectedProvider", "selectedPrice"];
				fieldsVal = [this.selectedSociety, this.selectedService, this.selectedProvider, this.selectedPrice];
			}

			if(this.purchase.isBillable){
				fields.push("selectedSellPrice");
				fieldsVal.push(this.selectedSellPrice);
			}

			let constname = "";

			for(let i = 0; i < fields.length; i++){
				let value = fieldsVal[i];
				if(value === 0) value = "0";
				switch(fields[i]){
				case"selectedPrice":
					/*
					 * case "selectedMarginPrice":
					 * case "marginRate":
					 */
				case"selectedSellPrice":
					value = value ? String(value) : "";
					constname = "priceConstraint";
					break;
				default:
					value = value ? String(value) : "";
					if(value == null) value = "";
					constname = "isNumberConstraint";
					break;
				}

				this.validators[fields[i]] = new Validator({constraintName: constname});
				this.validators[fields[i]].check(value);
				if(fieldsVal[i] == null) this.validators[fields[i]].valid = false;
				if(this.validators[fields[i]].valid == false && this.validators[fields[i]].errText == "") this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
				if(fields[i] == "selectedSellPrice" || fields[i] == "selectedPrice"){
					if(this.selectedService == 30 && this.selectedService == 29){
						/*
						 * this.selectedMarginPrice = null;
						 * this.purchase.marginRate = null;
						 */
						this.validators[fields[i]].valid = true;
						this.validators[fields[i]].errText = "";
					}
				}
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText !== "" ? this.check = false : "";
			}

			this.validators["boughtAt"] = new Validator({constraintName: "dateConstraint"});
			if(this.purchase.boughtAt == 0 || this.purchase.boughtAt == null){
				this.validators["boughtAt"].valid = false;
				this.validators["boughtAt"].errText = "Ce champ ne peut être vide.";
				this.check = false;
			}
			else{
				this.validators["boughtAt"].errText = "";
				this.validators["boughtAt"].valid = true;
			}

			this.$forceUpdate();

			if(this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement."
				});
				return false;
			}
			else{
				this.selectedPrice = Number(String(this.selectedPrice).replace(",", "."));
				this.selectedMarginPrice = Number(String(this.selectedMarginPrice).replace(",", "."));
				this.selectedSellPrice = Number(String(this.selectedSellPrice).replace(",", "."));
				this.purchase.marginRate = Number(String(this.purchase.marginRate).replace(",", "."));
				return new Promise((resolve, reject) => {
					if(this.selectedService == this.dnsServiceId){
						/*
						 * if(this.showNewDNS == true){
						 * Purchase DNS
						 */
						this.addPurchase(true)
							.then(result => {
								// Add DNS
								this.addDNS()
									.then(result2 => {
										// this.selectedDns = result2
										this.returnPrevRoute();
										resolve(result2);
										/*
										 * Add Netlink to DNS
										 * this.addNetlink(true)
										 * .then(result3 => {this.returnPrevRoute(); resolve(result3)})
										 * .catch(err3 => {//console.log(err3); reject(err3)})
										 */
									})
									.catch(err2 => {
										//console.log(err2); reject(err2);
									});
							})
							.catch(err => {
								//console.log(err); reject(err);
							});
						/*
						 * }
						 * else{
						 *   // Add Netlink to DNS
						 *   this.addNetlink(true)
						 *   .then(result => {this.returnPrevRoute(); resolve(result)})
						 *   .catch(err => {//console.log(err); reject(err)})
						 * }
						 */
					}
					else if(this.selectedService == this.netlinkServiceId){
						// Purchase Netlink
						this.addPurchase()
							.then(result => {
								// Add Netlink
								this.addNetlink()
									.then(result2 => {
										this.returnPrevRoute(); resolve(result2);
									})
									.catch(err2 => {
										//console.log(err2); reject(err2);
									});
							})
							.catch(err => {
								//console.log(err); reject(err);
							});
					}
					else{
						// Purchase Netlink
						this.addPurchase()
							.then(result => {
								this.returnPrevRoute();
								resolve(result);
							})
							.catch(err => {
								//console.log(err); reject(err);
							});
					}
				});
			}
		},

		/**
		 * Send the data to tha API to create the new user
		 * If the form is successfully sent, the user is redirect to Rankwell.vue
		 */
		formSubmitted() {
			let formatedDate = this.purchase.boughtAt.substring(0, 10);
			formatedDate = formatedDate.split("/").reverse().join("-");
			formatedDate = formatedDate + " 02:00:00";
			this.$http.post(this.apiUrl + "purchase/add", {
				price: this.convertFrenchNumberToInternational(this.selectedPrice),
				sell_price: this.convertFrenchNumberToInternational(this.selectedSellPrice),
				recurrence: this.purchase.recurrence,
				margin_price: this.convertFrenchNumberToInternational(this.selectedMarginPrice),
				margin_rate: this.purchase.marginRate,
				is_billable: this.purchase.isBillable,
				commentary: this.purchase.commentary,
				bought_at: formatedDate,
				netlink_id: this.purchase.netlink_id,
				contract_id: this.purchase.contract_id,
				contract_society_id: this.purchase.contract_society_id,
				users_id: this.purchase.users_id,
				service_id: this.purchase.service_id,
				is_delivered: this.purchase.is_delivered,
				recurrence_active: this.purchase.recurrence,
				mission_id: this.purchase.mission_id
			}).then(res => {
				//console.log(res);
				this.$store.dispatch("getAllPurchases");
				// Send a success notification to the user
				this.$vs.notify({title: "Succès", text: "Achat ajouté avec succès."});
				this.$router.go(-1);
			}).catch(err => {
				//console.log(err);
				this.$vs.notify({title: "Echec", text: "L'achat n'a pas été ajouté."});
			});
		},

		/**
		 * Send the data to tha API to create the new purchase and show Netlink
		 */
		formSubmittedAndShowNetlink() {
			this.check = true;
			let fields = ["selectedSociety", "selectedContract", "selectedService", "selectedProvider", "selectedPrice"];
			let fieldsVal = [this.selectedSociety, this.selectedContract, this.selectedService, this.selectedProvider, this.selectedPrice];
			if(this.purchase.isBillable){
				fields.push("selectedSellPrice");
				fieldsVal.push(this.selectedSellPrice);
			}
			let constname = "";

			for(let i = 0; i < fields.length; i++){
				let value = fieldsVal[i];
				value === 0 ? value = "0" : "";
				switch(fields[i]){
				case"selectedPrice":
					/*
					 * case "selectedMarginPrice":
					 * case "marginRate":
					 */
				case"selectedSellPrice":
					value ? value = String(value) : "";
					constname = "priceConstraint";
					break;
				default:
					value ? value = String(value) : "";
					value == null ? value = "" : "";
					constname = "isNumberConstraint";
					break;
				}

				this.validators[fields[i]] = new Validator({constraintName: constname});
				this.validators[fields[i]].check(value);
				fieldsVal[i] == null ? this.validators[fields[i]].valid = false : "";
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText == "" ? this.validators[fields[i]].errText = "Ce champ ne peut être vide." : "";
				if(fields[i] == "selectedSellPrice" || fields[i] == "selectedPrice"){
					if(this.selectedService == 30 && this.selectedService == 29){
						this.selectedMarginPrice = null;
						this.purchase.marginRate = null;
						this.validators[fields[i]].valid = true;
						this.validators[fields[i]].errText = "";
					}
				}
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText !== "" ? this.check = false : "";
			}

			this.validators["boughtAt"] = new Validator({constraintName: "dateConstraint"});
			if(this.purchase.boughtAt == 0 || this.purchase.boughtAt == null){
				this.validators["boughtAt"].valid = false;
				this.validators["boughtAt"].errText = "Ce champ ne peut être vide.";
				this.check = false;
			}
			else{
				this.validators["boughtAt"].errText = "";
				this.validators["boughtAt"].valid = true;
			}

			this.$forceUpdate();

			if(this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement."
				});
				return false;
			}
			else{
				this.selectedPrice = Number(String(this.selectedPrice).replace(",", "."));
				this.selectedMarginPrice = Number(String(this.selectedMarginPrice).replace(",", "."));
				this.selectedSellPrice = Number(String(this.selectedSellPrice).replace(",", "."));
				this.purchase.marginRate = Number(String(this.purchase.marginRate).replace(",", "."));
				this.purchaseLocked = true;
				this.purchaseDefinitiveLock = true;
				this.showNetlinkPopup = true;
				/*
				 * let formatedDate = this.purchase.boughtAt.substring(0,10)
				 * formatedDate = formatedDate.split('/').reverse().join('-')
				 * formatedDate = formatedDate + " 02:00:00"
				 * this.$http.post(this.apiUrl + "purchase/add", {
				 *   price: this.convertFrenchNumberToInternational(this.selectedPrice),
				 *   recurrence: this.purchase.recurrence,
				 *   margin_price: this.convertFrenchNumberToInternational(this.selectedMarginPrice),
				 *   margin_rate: this.purchase.marginRate,
				 *   is_billable: this.purchase.isBillable,
				 *   commentary: this.purchase.commentary,
				 *   bought_at: formatedDate,
				 *   contract_id: this.purchase.contract_id,
				 *   contract_society_id: this.purchase.contract_society_id,
				 *   users_id: this.purchase.users_id,
				 *   service_id: this.purchase.service_id,
				 *   is_delivered: 0,
				 *   recurrence_active: this.purchase.recurrence
				 * }).then(res => {
				 *   //console.log(res)
				 *   this.purchaseId = res.data.insertId
				 *   //console.log(this.purchaseId)
				 *   this.showNetlinkPopup = true
				 *   this.$store.dispatch("getAllPurchases");
				 *   // Send a success notification to the user
				 *   this.$vs.notify({title:'Succès',text:"Achat ajouté avec succès."})
				 * }).catch(err => {
				 *   //console.log(err)
				 *   this.$vs.notify({title:'Echec',text:"L'achat n'a pas été ajouté."})
				 * })
				 */
			}
		},

		formSubmittedAndShowDns() {
			this.check = true;
			let fields = ["selectedSociety", "selectedService", "selectedProvider", "selectedPrice"];
			let fieldsVal = [this.selectedSociety, this.selectedService, this.selectedProvider, this.selectedPrice];
			if(this.purchase.isBillable){
				fields.push("selectedSellPrice");
				fieldsVal.push(this.selectedSellPrice);
			}
			let constname = "";

			for(let i = 0; i < fields.length; i++){
				let value = fieldsVal[i];
				value === 0 ? value = "0" : "";
				switch(fields[i]){
				case"selectedPrice":
					/*
					 * case "selectedMarginPrice":
					 * case "marginRate":
					 */
				case"selectedSellPrice":
					value ? value = String(value) : "";
					constname = "priceConstraint";
					break;
				default:
					value ? value = String(value) : "";
					value == null ? value = "" : "";
					constname = "isNumberConstraint";
					break;
				}

				this.validators[fields[i]] = new Validator({constraintName: constname});
				this.validators[fields[i]].check(value);
				fieldsVal[i] == null ? this.validators[fields[i]].valid = false : "";
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText == "" ? this.validators[fields[i]].errText = "Ce champ ne peut être vide." : "";
				if(fields[i] == "selectedSellPrice" || fields[i] == "selectedPrice"){
					if(this.selectedService == 30 && this.selectedService == 29){
						this.selectedMarginPrice = null;
						this.purchase.marginRate = null;
						this.validators[fields[i]].valid = true;
						this.validators[fields[i]].errText = "";
					}
				}
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText !== "" ? this.check = false : "";
			}

			this.validators["boughtAt"] = new Validator({constraintName: "dateConstraint"});
			if(this.purchase.boughtAt == 0 || this.purchase.boughtAt == null){
				this.validators["boughtAt"].valid = false;
				this.validators["boughtAt"].errText = "Ce champ ne peut être vide.";
				this.check = false;
			}
			else{
				this.validators["boughtAt"].errText = "";
				this.validators["boughtAt"].valid = true;
			}

			this.$forceUpdate();

			if(this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement."
				});
				return false;
			}
			else{
				this.selectedPrice = Number(String(this.selectedPrice).replace(",", "."));
				this.selectedMarginPrice = Number(String(this.selectedMarginPrice).replace(",", "."));
				this.selectedSellPrice = Number(String(this.selectedSellPrice).replace(",", "."));
				this.purchase.marginRate = Number(String(this.purchase.marginRate).replace(",", "."));
				/*
				 * this.purchaseLocked = true
				 * this.purchaseDefinitiveLock = true
				 * let formatedDate = this.purchase.boughtAt.substring(0,10)
				 * formatedDate = formatedDate.split('/').reverse().join('-')
				 * formatedDate = formatedDate + " 02:00:00"
				 * this.$http.post(this.apiUrl + "purchase/add", {
				 *   price: this.convertFrenchNumberToInternational(this.purchase.price),
				 *   recurrence: this.purchase.recurrence,
				 *   margin_price: this.convertFrenchNumberToInternational(this.purchase.marginPrice),
				 *   margin_rate: this.purchase.marginRate,
				 *   is_billable: this.purchase.isBillable,
				 *   commentary: this.purchase.commentary,
				 *   bought_at: formatedDate,
				 *   contract_id: this.purchase.contract_id,
				 *   contract_society_id: this.purchase.contract_society_id,
				 *   users_id: this.purchase.users_id,
				 *   service_id: this.purchase.service_id,
				 *   is_delivered: 0,
				 *   recurrence_active: this.purchase.recurrence
				 * }).then(res => {
				 *   //console.log(res)
				 *   this.purchaseId = res.data.insertId
				 *   //console.log(this.purchaseId)
				 */
				this.showDnsPopup = true;
				/*
				 *   this.$store.dispatch("getAllPurchasesWithRecurring");
				 *   // Send a success notification to the user
				 *   this.$vs.notify({title:'Succès',text:"Achat ajouté avec succès."})
				 * }).catch(err => {
				 *   //console.log(err)
				 *   this.$vs.notify({title:'Echec',text:"L'achat n'a pas été ajouté."})
				 * })
				 */
			}
		},

		enterEditMode(){
			if(!this.atLeastOneNetlink){
				this.purchaseDefinitiveLock = false;
			}
			this.showNetlinkPopup = false;
			this.showDnsPopup = false;
			this.editPurchaseMode = true;
			this.purchaseLocked = false;
		},

		editFormSubmittedAndShowNetlink() {
			this.purchaseLocked = true;
			this.purchaseDefinitiveLock = true;
			let formatedDate = this.purchase.boughtAt.substring(0, 10);
			formatedDate = formatedDate.split("/").reverse().join("-");
			formatedDate = formatedDate + " 02:00:00";
			this.$http.post(this.apiUrl + "purchase/edit", {
				id: this.purchaseId,
				price: this.convertFrenchNumberToInternational(this.selectedPrice),
				sell_price: this.convertFrenchNumberToInternational(this.selectedSellPrice),
				recurrence: this.purchase.recurrence,
				margin_price: this.convertFrenchNumberToInternational(this.selectedMarginPrice),
				margin_rate: this.purchase.marginRate,
				is_billable: this.purchase.isBillable,
				commentary: this.purchase.commentary,
				bought_at: formatedDate,
				contract_id: this.purchase.contract_id,
				contract_society_id: this.purchase.contract_society_id,
				users_id: this.purchase.users_id,
				service_id: this.purchase.service_id,
				is_delivered: 0,
				recurrence_active: this.purchase.recurrence,
				mission_id: this.purchase.mission_id
			}).then(res => {
				//console.log(res);
				this.showNetlinkPopup = true;
				this.$store.dispatch("getAllPurchases");
				// Send a success notification to the user
				this.$vs.notify({title: "Succès", text: "Achat modifié avec succès."});
			}).catch(err => {
				//console.log(err);
				this.$vs.notify({title: "Echec", text: "L'achat n'a pas été modifié."});
			});
		},

		editFormSubmitted() {
			this.purchaseLocked = true;
			let formatedDate = this.purchase.boughtAt.substring(0, 10);
			formatedDate = formatedDate.split("/").reverse().join("-");
			formatedDate = formatedDate + " 02:00:00";
			this.$http.post(this.apiUrl + "purchase/edit", {
				id: this.purchaseId,
				price: this.convertFrenchNumberToInternational(this.selectedPrice),
				sell_price: this.convertFrenchNumberToInternational(this.selectedSellPrice),
				recurrence: this.purchase.recurrence,
				margin_price: this.convertFrenchNumberToInternational(this.selectedMarginPrice),
				margin_rate: this.purchase.marginRate,
				is_billable: this.purchase.isBillable,
				commentary: this.purchase.commentary,
				bought_at: formatedDate,
				contract_id: this.purchase.contract_id,
				contract_society_id: this.purchase.contract_society_id,
				users_id: this.purchase.users_id,
				service_id: this.purchase.service_id,
				is_delivered: 0,
				recurrence_active: this.purchase.recurrence,
				mission_id: this.purchase.mission_id
			}).then(res => {
				//console.log(res);
				this.$store.dispatch("getAllPurchases");
				// Send a success notification to the user
				this.$vs.notify({title: "Succès", text: "Achat modifié avec succès."});
				this.$router.go(-1);
			}).catch(err => {
				//console.log(err);
				this.$vs.notify({title: "Echec", text: "L'achat n'a pas été modifié."});
			});
		},

		/**
		 * Send the data to tha API to create the new netlinks
		 */
		netlinkSubmitted() {
			this.$router.go(-1);
		},

		displayMissionsPopup(){
			this.showMissionsPopup = true;
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		},


		getAllProductsCategories(){
			this.$store.dispatch("getAllProductsCategories");
		},

		getAllServices(){
			this.$store.dispatch("getAllServices");
		},
		/**
		 * Get all societies in store states
		 */
		getAllSocieties(){
			this.$store.dispatch("getAllSocieties");
		},
		getAllProviders(){
			this.$store.dispatch("getAllProviders");
		},
		getAllContractsForSociety(societyId){
			Contract.getContractsforSociety(societyId, (err, res) => {
				if(err) //console.log(err);
				if(res){
					//console.log(res);
					this.contractOptions = res.filter(row => [1, 3, 4].includes(row.status));
					if(this.contractOptions.length > 0){
						this.selectedContract = this.purchase.contract_id;
					}
					else{
						this.selectedContract = null;
					}
				}
			});
			//console.log("getAllContractsForSociety");
		},
		getAllMissionsForContract(contractId){
			//console.log(contractId);
			Mission.getMissionsForContract(contractId, (err, res) => {
				if(err) //console.log(err);
				if(res) {
					this.missionsOfSociety = res;
					let missionList = [];
					for(let mission of this.missionsOfSociety){
						let item;

						// if(mission.commentary){
						// 	if(this.products.filter(product => product.id == mission.products_id && product.sub_category == 7).length > 0) item = `${this.products.filter(product => product.id == mission.products_id && product.sub_category == 7)[0].perform}: ${mission.commentary}`;
						// }else{
						// 	if(this.products.filter(product => product.id == mission.products_id && product.sub_category == 7).length > 0) item = this.products.filter(product => product.id == mission.products_id && product.sub_category == 7)[0].perform;
						// }

						if(mission.commentary){
							if(this.products.filter(product => product.id == mission.products_id).length > 0) item = `${this.products.filter(product => product.id == mission.products_id)[0].perform}: ${mission.commentary}`;
						}
						else{
							if(this.products.filter(product => product.id == mission.products_id).length > 0) item = this.products.filter(product => product.id == mission.products_id)[0].perform;
						}
						if(item) missionList.push([mission.id, item]);
					}
					this.productOptions = missionList;
					if(this.productOptions.length > 0 && this.initial > 1) this.selectedProduct = this.productOptions[0][0]
					else if(this.productOptions.length > 0 && this.initial == 1) this.selectedProduct = this.purchase.mission_id
					else this.selectedProduct = null
				}
			});
			//console.log("getAllMissionsForContract");
		},
		setServiceOptions(provider_id){
			let foundProvider = this.providers.find(provider => provider_id == provider.id);
			return foundProvider.service_id_list.split(",");
		},

		setServiceOptionsAndSetService(provider_id, service_id){
			// Call API get service options for provider
			let newProvider = new Provider(this.providers.find(provider => provider_id == provider.id));
			//console.log("newProvider");
			//console.log(newProvider);
			// "/providersServices/getsu/" + this.id
			this.$http.get(this.apiUrl + "providersServices/getsu/" + newProvider.id)
				.then(res => {
					//console.log("res");
					//console.log(res.data);
					this.serviceOptions = [];
					for(let service of res.data){
						this.serviceOptions.push(service.service_id);
					}
					this.selectedService = service_id;
				})
				.catch(err => {
					//console.log("err");
					//console.log(err);
				});
			//console.log("setServiceOptionsAndSetService");
		},

		getServiceName(service_id){
			let service = this.services.find(service_element => service_element.id == service_id);
			return service.name;
		},

		checkServiceIsNetlink(service_id){
			let service = this.services.find(service => service.id == service_id);
			if(service != undefined){
				if(service.name == this.netlinkServiceName){
					return true;
				}
			}
			return false;
		},

		checkServiceIsDns(service_id){
			let service = this.services.find(service => service.id == service_id);
			if(service != undefined){
				if(service.name == this.dnsServiceName){
					return true;
				}
			}
			return false;
		},

		checkNetlinkNumber(netlinkNumber){
			if(netlinkNumber >= 1){
				this.atLeastOneNetlink = true;
			}
			else{
				this.atLeastOneNetlink = false;
				if(!this.purchaseLocked){
					this.purchaseDefinitiveLock = false;
				}
			}
		},
	}
};
</script>

<style scoped>
.nowrap {
  display: flex;
  align-items: baseline;
}

.role_selector_container {
  justify-content: space-between;
  width: 40%;
}

.role_container {
  justify-content: center;
}

.space_div {
  margin: 5px;
}
</style>
